import FloatFormat from "../FloatFormat";

interface IText {
  value: string | number;
}


const Integer = ({ value }: IText) => {

  return (
    <>
     {!!value ? <FloatFormat value={value} /> : '—'}
    </>
  );
};

export default Integer;
